import { FC } from 'react';

import { ICON_STROKE_WIDTH } from 'views/components/UI/Icons/icons.constants';
import { IIconProps } from 'views/components/UI/Icons/icons.interface';

const PriorityMinor: FC<IIconProps> = ({
  size = '16',
  color = 'var(--sk-text-accent-sky)',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 5.33887L6.98985 9.32872C7.54774 9.88661 8.45226 9.88661 9.01015 9.32872L13 5.33887"
      stroke={color}
      strokeWidth={ICON_STROKE_WIDTH}
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);

export { PriorityMinor };
